import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'

export const getFilteredAppConfigs = (
  apps: ReturnType<typeof useAvailableApps>['apps']
) => {
  return Object.entries(apps).filter(([_, config]) => !!config.component)
}
